/* main.js — page-level behaviour. Owner: PAGE-SCAFFOLD.
   Scroll-reveal for [data-animate]. Section JS lives in js/<slug>.js. */
(function () {
  'use strict';

  var animated = document.querySelectorAll('[data-animate]');
  if (!animated.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    animated.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  animated.forEach(function (el) { io.observe(el); });
})();
